module.exports = __webpack_public_path__ + "resources/img/main_banner_ngsc02.bbe8541bcb1c6b6079c13e6abf55fce1.png";